import { render } from "./SenaraiAiman.vue?vue&type=template&id=8142de6a"
import script from "./SenaraiAiman.vue?vue&type=script&lang=js"
export * from "./SenaraiAiman.vue?vue&type=script&lang=js"

import "./SenaraiAiman.vue?vue&type=style&index=0&id=8142de6a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__